import { Map as iMap, List as iList, fromJS } from 'immutable';
import { contains, either, isNil, isEmpty } from 'ramda';
import * as cnt from '../../components/connections/__storeFiles__/actions';
const isNilOrEmpty = either(isNil, isEmpty);

const initialState = iMap({
  oldConnections: iList(),
  oldConnectionId: undefined,
  resultCount: undefined,
  items: iList(),
  searchString: undefined,
  page: 1,
  nextPage: undefined,
  prevPage: undefined,
  countries: iList(),
  filteredCountries: iList(),
  unfilteredConnections: iList(),
});

export function connections(state = initialState, action) {
  switch (action.type) {
    case `${cnt.ADD_CONNECTION_AS_PARTNER}_SUCCESS`:
      return state.update('items', items => items.map(item => {
        if (item.get('id') === action.payload.connectionId) return item.set('partner', action.payload.partner);
        return item;
      })).update('unfilteredConnections', items => items.map(item => {
        if (item.get('id') === action.payload.connectionId) return item.set('partner', action.payload.partner);
        return item;
      }));
    case 'CONNECTIONS_IS_SYNCING':
      return state.set('isSyncing', true);
    case 'GET_COUNTRIES':
      return state.set('countries', fromJS(action.payload));
    case 'FILTER_CONNECTIONS':
      if (isNilOrEmpty(state.get('unfilteredConnections')) || action.payload.status !== 'all') {
        return state.merge(fromJS(action.payload))
                    .set('unfilteredConnections', fromJS(action.payload.items));
      }
      return state.merge(fromJS(action.payload));
    case 'FILTER_CONNECTIONS_BY_COUNTRY':
      return state.merge(fromJS(action.payload)).set('isSyncing', false);
    case 'LOAD_MORE_CONNECTIONS':
      // if (state.get('page') === state.get('nextPage')) return state;
      return state.set('items', fromJS(action.payload.items))
                  .set('isSyncing', false)
                  .set('page', action.payload.page)
                  .set('nextPage', action.payload.page + 1)
                  .set('unfilteredConnections', fromJS(action.payload.items));
    case 'ACCEPT_CONNECTION_STARTING':  // accept
    case 'IGNORE_CONNECTION_STARTING':  // reject
    case 'REMOVE_CONNECTION_STARTING':  // archive
      const oldConnectionId = action.payload;
      const oldConnections = state.get('items');
      return state.update('items', items => items.filter(item => item.get('id') !== oldConnectionId))
                  .set('oldConnections', oldConnections)
                  .set('oldConnectionId', oldConnectionId);
    case 'RESEND_CONNECTION_STARTING':
      return state.update('items', items =>
        items.map(item => {
          if (item.get('id') === action.payload) return item.set('lastSent', 'a few seconds ago');
          return item;
        }));
    case 'UNDO_CONNECTION_CHANGE':
      return state.set('items', oldConnections).set('oldConnections', iList()).set('oldConnectionId', undefined);
    case 'CLEAR_STORES':
      return initialState;
    case 'ADD_TAG_STARTING':
      const updateItems = items => items.map(item => {
        if (item.get('id') === action.payload.connectionId && item.get('tags').indexOf(action.payload.tagName) === -1) return item.update('tags', tags => tags.unshift(action.payload.tagName));
        return item;
      });
      return state.update('items', () => updateItems(state.get('items')))
                  .update('unfilteredConnections', () => updateItems(state.get('items')));
    case 'REMOVE_TAG_STARTING':
      const update = items => items.map(item => {
        if (item.get('id') === action.payload.connectionId) return item.update('tags', tags => tags.filter(tag => tag !== action.payload.tagName));
        return item;
      });
      return state.update('items', () => update(state.get('items')))
                  .update('unfilteredConnections', () => update(state.get('items')));
    case 'REMOVE_COUNTRY_FILTER':
      return state.update('filteredCountries', countries => countries.filter(country => country !== action.payload));
    case 'DELETED_TAG':
      return state.update('items', items => items.map(item => {
        if (contains(action.payload.tagName, item.get('tags'))) return item.update('tags', tags => tags.filter(tag => tag !== action.payload.tagName));
        return item;
      }));
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/connections/connections-reducer.js